module.exports = __webpack_public_path__ + "img/cowise1.da3303a0.png";